<template>
  <div
    class="flex flex-wrap lg:flex-nowrap justify-between items-center px-6 lg:px-12 lg:h-20 w-full fixed top-0 left-0 z-50 bg-white"
  >
    <a href="/">
      <img class="py-2" src="/img/cw-logo.png" alt="CareerWise logo" />
    </a>
    <div class="hidden md:flex h-full space-x-4 items-center">
      <a
        class="font-nunito p-2 m-0 cursor-pointer no-underline hover:text-cw-700"
        @click="pushRoute('Home')"
        >Home</a
      >
      <!--
        <a
        class="font-nunito p-2 m-0 cursor-pointer no-underline hover:text-cw-700"
        @click="pushRoute('Pricing')"
        >Pricing</a
        > 
      -->
      <!--
        <div
        @click="showDropdownMenu('benefits', true)"
        @mouseover="showDropdownMenu('benefits', true)"
        @mouseleave="showDropdownMenu('benefits', false)"
        >
        <a
        class="font-nunito p-2 m-0 no-underline hover:text-cw-700 relative flex"
        >
        Benefits
        <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 ml-1"
        viewBox="0 0 20 20"
        fill="currentColor"
        >
        <path
        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
        />
        </svg>
        </a>

        <div
        v-show="showingMenuBenefits"
        class="absolute inset-auto bg-white flex flex-col py-2 px-4"
        >
        <a
        class="font-nunito p-2 m-0 cursor-pointer no-underline hover:text-cw-700"
        @click="pushRoute('BenefitsSchools')"
        >
        Schools
        </a>
        <a
        class="font-nunito p-2 m-0 cursor-pointer no-underline hover:text-cw-700"
        @click="pushRoute('BenefitsBusinesses')"
        >
        Tertiary/Employers
        </a>
        </div>
        </div> 
      -->

      <div @click="open = 1" @mouseover="open = 1" @mouseleave="toggleMenu(1)">
        <a
          class="font-nunito p-2 m-0 no-underline hover:text-cw-700 relative flex"
          >CareerWise for
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 ml-1"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
            ></path>
          </svg>
        </a>

        <div
          v-show="open === 1"
          class="absolute inset-auto bg-white flex flex-col py-2 px-4"
        >
          <a
            class="font-nunito p-2 m-0 cursor-pointer no-underline hover:text-cw-700"
            @click="pushRoute('CWForSchools')"
            >Schools</a
          >
          <a
            class="font-nunito p-2 m-0 cursor-pointer no-underline hover:text-cw-700"
            @click="pushRoute('CWForBusinesses')"
            >Tertiary/PTE's and Employers</a
          >
        </div>
      </div>

      <a
        class="font-nunito p-2 m-0 cursor-pointer no-underline hover:text-cw-700"
        @click="pushRoute('CWConnections')"
      >
        Connections
      </a>

      <a href="/account" class="font-nunito btn btn-black no-underline h-12 m-0"
        >Sign in</a
      >
    </div>
    <!-- mobile menu -->
    <div class="flex md:hidden">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        class="cursor-pointer h-8 w-8 hover:text-cw-700"
        @click="toggleMenu(2)"
      >
        <path
          data-v-3ef16b00=""
          fill-rule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clip-rule="evenodd"
        ></path>
      </svg>
      <Transition name="fade">
        <div
          v-if="open === 2"
          class="absolute left-0 top-0 flex flex-col h-screen w-screen sm:space-x-4 items-center justify-center bg-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="absolute top-12 right-12 cursor-pointer h-8 w-8 hover:text-cw-700"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            @click="toggleMenu(2)"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
          <a
            v-for="(item, i) in menu"
            :key="i"
            class="font-nunito text-3xl py-4 m-0 cursor-pointer no-underline hover:text-cw-700 text-center"
            @click="pushRoute(item.route)"
            >{{ item.name }}
          </a>

          <a
            href="/account"
            class="font-nunito text-3xl py-4 m-0 cursor-pointer no-underline hover:text-cw-700"
          >
            Sign in
          </a>
        </div>
      </Transition>
    </div>

    <!--
      <div class="flex sm:hidden space-x-4 pt-2 items-center justify-center w-full">
      <a :style="[{height:'fit-content'}]" target="_blank" href="https://www.facebook.com/careerwise.school">
      <img :style="[{height:'18px'}]" class="flex-shrink-0" src="/img/icons/facebook.svg" alt="Facebook">
      </a>
      <a :style="[{height:'fit-content'}]" target="_blank" href="https://www.linkedin.com/company/careerwisenz/">
      <img class="h-6 flex-shrink-0" src="/img/icons/linkedin.svg" alt="Linked In">
      </a>
      </div> 
    -->
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { EventBus } from '../../../js/plugins/event-bus.js'

export default {
  mixins: [shared],

  data() {
    return {
      open: null,
      showingMenuBenefits: false,
      menu: [
        {
          path: '/',
          name: 'Home',
          route: 'Home',
        },
        // {
        //   name: 'Pricing',
        //   route: 'Pricing',
        // },
        // {
        //   name: 'Features',
        //   route: 'Features',
        // },

        {
          name: 'Schools',
          route: 'CWForSchools',
        },
        {
          name: "Tertiary/PTE's and Employers",
          route: 'CWForBusinesses',
        },
        {
          name: 'Connections',
          route: 'CWConnections',
        },
      ],
    }
  },

  methods: {
    // Type of enquiry; 0 === information, 1 === demo, 2 === sign up, 3 === upgrade plan, 4 === other, 5 === Hail
    toggleCwRegistration(type) {
      EventBus.$emit('showModal', 'cw-registration')
      setTimeout(() => {
        EventBus.$emit('new_reason', type)
      }, 50)
    },

    // Type of menu; 1 === submenu, 2 === mobile
    toggleMenu(id) {
      this.open = this.open === id ? null : id
      if (id === 2) {
        document.body.classList.toggle('fixed')
      }
    },

    pushRoute(route) {
      if (this.$router.history.current.name !== route) {
        this.$router.push({ name: route })
      }
      this.closeMobileMenu()
    },

    closeMobileMenu() {
      this.open = null
      document.body.classList.remove('fixed')
    },

    showDropdownMenu(type, value) {
      if (type === 'benefits') {
        this.showingMenuBenefits = value
      }
    },
  },
}
</script>

<style scoped>
.v-enter-active,
.v-leave-active,
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to,
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transition: opacity 0.2s ease;
}
</style>
